module.exports = require('./helpers/bundle-url').getBundleURL('gnRNX') + "team-reports-upsell-illustration-2x.5e4a9336.png" + "?" + Date.now();